import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    visible: boolean;
    onToggle: () => void;
}

/** The "Show" / "Hide" text button that sits inside a password field. */
export const PasswordToggle: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    return (
        <button
            type="button"
            className="auth-layout__password-toggle"
            aria-label={t(props.visible ? 'auth.password.hideLabel' : 'auth.password.showLabel')}
            aria-pressed={props.visible}
            onClick={props.onToggle}
        >
            {t(props.visible ? 'auth.password.hide' : 'auth.password.show')}
        </button>
    );
};
